import { useTranslation } from 'react-i18next';
import i18nInstance from '../../localeImport.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

/**
 * Footer component
 * @returns Footer component
 */
function Footer({
  privacyPolicy,
  termsOfService
}) {
  const [t] = useTranslation(undefined, {
    i18n: i18nInstance
  });
  return /*#__PURE__*/jsxs("div", {
    className: "w3a--mx-auto w3a--mt-auto w3a--flex w3a--flex-col w3a--items-center w3a--justify-center w3a--gap-y-4 w3a--pt-5",
    children: [(privacyPolicy || termsOfService) && /*#__PURE__*/jsxs("p", {
      className: "w3a--mx-auto w3a--w-4/5 w3a--text-center w3a--text-xs w3a--text-app-gray-500 dark:w3a--text-app-gray-400",
      children: [t("modal.footer.by-signing-in"), " ", termsOfService && /*#__PURE__*/jsxs("a", {
        href: termsOfService,
        className: "w3a--text-app-primary-600 dark:w3a--text-app-primary-500",
        children: [t("modal.footer.terms-of-service"), " "]
      }), privacyPolicy && /*#__PURE__*/jsxs(Fragment, {
        children: [t("modal.footer.and"), " ", /*#__PURE__*/jsx("a", {
          href: privacyPolicy,
          className: "w3a--text-app-primary-600 dark:w3a--text-app-primary-500",
          children: t("modal.footer.privacy-policy")
        })]
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: "w3a--flex w3a--items-center w3a--justify-center w3a--gap-2",
      children: [/*#__PURE__*/jsx("img", {
        height: "36",
        src: "https://images.web3auth.io/metamask-footer-logo-light.svg",
        alt: "Web3Auth Logo Light",
        className: "w3a--block w3a--h-9 dark:w3a--hidden"
      }), /*#__PURE__*/jsx("img", {
        height: "36",
        src: "https://images.web3auth.io/metamask-footer-logo-dark.svg",
        alt: "Web3Auth Logo Dark",
        className: "w3a--hidden w3a--h-9 dark:w3a--block"
      })]
    })]
  });
}

export { Footer as default };
